import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { PriceProvider } from './context';
import { PointsProvider } from "./sportsc/pointContext";
import { ArtclesProvider } from "./sportsc/articlesContext";
import { PredProvider } from "./sportsc/predContext";
ReactDOM.render(
  <React.StrictMode>
    <PredProvider>
    <ArtclesProvider>
    <PriceProvider>
    <PointsProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </PointsProvider>
    </PriceProvider>
    </ArtclesProvider>
    </PredProvider>
  </React.StrictMode>,
  document.getElementById("root")
);